let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("efsEI")).then(() => parcelRequire('bkp4a'));